import { render } from "./DisplayLayout.vue?vue&type=template&id=1a5c2ace&scoped=true"
import script from "./DisplayLayout.vue?vue&type=script&lang=js"
export * from "./DisplayLayout.vue?vue&type=script&lang=js"

import "./DisplayLayout.vue?vue&type=style&index=0&id=1a5c2ace&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5c2ace"]])

export default __exports__